<div class="RelatedPosts">
  <h2 class="Reference" [innerHtml]="isCompetition(docType)"></h2>
  <ul class="Cards">
    <li *ngFor="let relatedDoc of relatedDocuments">
      <related-doc [relatedDoc]="relatedDoc" [relationType]="'relation'"></related-doc>
    </li>
  </ul>
</div>
